module.exports = __webpack_public_path__ + "img/printemps_1.1ac98d72.jpg";